'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var noticeAnnouncement = function noticeAnnouncement() {
  return import('@/page/notice-announcement');
};
var messageDetail = function messageDetail() {
  return import('@/page/notice-announcement/message-detail');
};
var noticeList = function noticeList() {
  return import('@/page/notice-announcement/notice-list');
};
var systemDetail = function systemDetail() {
  return import('@/page/notice-announcement/system-detail');
};
exports.default = [{
  path: '/notice-announcement',
  name: 'notice-announcement',
  component: noticeAnnouncement,
  children: [{
    path: 'message-detail',
    name: 'message-detail',
    component: messageDetail
  }, {
    path: 'notice-list',
    name: 'notice-list',
    component: noticeList
  }, {
    path: 'system-detail',
    name: 'system-detail',
    component: systemDetail
  }]
}];